import { qweIsEmpty } from '@/common/commonHelper';
import { FilterConfig } from './index';
import { getFieldDefinition } from '../../apis/httpHelper';

export default {
    props:{
        supportSelectedFields:{
            type: Array,
        },

        filterItem:{
            type: Object
        },

        contentType:{
            type: String
        }
    },

    emits:["addItem","deleteItem"],

    data:function(){
        return {
            operatorOptions:[]
        }
    },  

    computed:{
        contentDefinition:function(){
            return (this.supportSelectedFields.find(x=> x.value == this.filterItem.field) || {"definition":{}}).definition;
        }
    },  

    created:function(){
        if(qweIsEmpty(this.filterItem.field)){
            if(qweIsEmpty(this.filterItem.operator)){
                this.filterItem.operator = FilterConfig[this.filterItem.fieldType].defaulOperator;
            }
        }
        this.operatorOptions = FilterConfig[this.filterItem.fieldType].operatorOptions;
        this.$watch("filterItem.field",function(newValue,oldValue){
            if(qweIsEmpty(newValue)){
                return;
            }
            let contentDefinition = this.supportSelectedFields.find(x=> x.value == newValue);
            this.operatorOptions = FilterConfig[contentDefinition.fieldType].operatorOptions;
            this.filterItem.operator = FilterConfig[contentDefinition.fieldType].defaulOperator;
            this.filterItem.fieldType = contentDefinition.fieldType;
            this.filterItem.value = FilterConfig[contentDefinition.fieldType].createFilter();
        });
    },

    methods:{
        initFilter:function(){

        },

        add:function(){
            this.$emit("addItem");
        },

        remove:function(){
            this.$emit("deleteItem",this.filterItem.guid);
        }
    },
}